window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Intercept Errors
window.axios.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        console.log(error.response)
        if (error.response && error.response.data) {
            // Error in validation
            if (error.response.status === 422) {
                Vue.$toast.info('Ops! Error');
            }

            // Error Common
            if (error.response.status === 406) {
                Vue.$toast.error(error.response.data.message);
            }
        }
        return Promise.reject(error);
    }
);

// Boostrap 4 Helpers
$(function () {
    $('[data-toggle="tooltip"]').tooltip()
    // $('[data-toggle="popover"]').popover()

    $('.sidebar-dropdown > a').each(function(i, v){
        if (!$(v).hasClass('active')) {
            $(v)
                .next(".sidebar-submenu")
                .slideUp(200);
        }
    });

    $(".sidebar-dropdown > a").click(function() {
        $(".sidebar-submenu").slideUp(200);
        if (
            $(this)
                .parent()
                .hasClass("active")
        ) {
            $(".sidebar-dropdown").removeClass("active");
            $(this)
                .parent()
                .removeClass("active");
        } else {
            $(".sidebar-dropdown").removeClass("active");
            $(this)
                .next(".sidebar-submenu")
                .slideDown(200);
            $(this)
                .parent()
                .addClass("active");
        }
    });

})

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
